<template>
  <div class="b2c-offical-wrapper-ab">
    <div
      v-zpm="{
        sectionid: 156,
        sortid: 0,
        sortname: '平台承诺',
        areaexposure: 156,
        legoareabackup: {
          sortName: '平台承诺',
        },
      }"
      class="offical-bar"
      @click="_showPopup"
    >
      <div v-for="(item, i) in officialInfo" :key="i" class="offical-bar-item">
        <img :src="$setPicSize(item.logo)" alt="" />
        <span>{{ item.name }}</span>
      </div>
      <div class="offical-bar-more">了解详细</div>
    </div>
    <common-popup :show="showPopup" :headMsg="headMsg" @close="close">
      <div class="b2c-popup-content">
        <div v-for="i in popupInfoData" :key="i.name" class="popup-item">
          <div class="desc_title">{{ i.name }}</div>
          <div class="desc_value">
            {{ i.desc }}
          </div>
        </div>
        <p class="popup-desc">{{ commentPopup.bottomText }}</p>
        <section v-show="showFeedback && feedbackVal" class="feed-back">
          <z-platform-bch-entry
            type="bottom"
            questionnaireId="1647862956798513664"
            :canBack="1"
            :openType="3"
            :outAppOpenType="2"
            getContainer="body"
            position="right"
            :extend="{
              pageName: '商品质量承诺',
              ...feedbackData,
            }"
            @watchShow="feedbackCallback"
          />
        </section>
      </div>
    </common-popup>
  </div>
</template>
<script>
  import { Popup, PlatformBchEntry } from '@zz-common/zz-ui'
  import CommonPopup from './common-popup'
  import { setPicSize } from '@zz-common/zz-utils'
  import { getCommitment } from '../../apis/index'
  export default {
    props: {
      showFeedback: {
        type: Boolean,
        default: false,
      },
      feedbackData: {
        type: Object,
        default: () => {},
      },
      infoData: {
        type: Array,
        default: () => [],
      },
    },
    components: {
      [Popup.name]: Popup,
      [PlatformBchEntry.name]: PlatformBchEntry,
      CommonPopup,
    },
    data() {
      return {
        feedbackVal: true, //组件给的是否展示入口的回调值
        showPopup: false,
        commentPopup: [],
        officialInfo: [
          {
            logo: 'https://pic3.zhuanstatic.com/zhuanzh/378280ef-4045-446a-9fbf-42d76d7e8aba.png',
            name: '拒绝仿冒',
          },
          {
            logo: 'https://pic3.zhuanstatic.com/zhuanzh/74855ed9-5ffd-493c-b0fb-290bc5f6d677.png',
            name: '无核心部件拆修',
          },
          {
            logo: 'https://pic1.zhuanstatic.com/zhuanzh/1d0e2d23-19a1-40c0-9d69-e433241c3f18.png',
            name: '无电池异常',
          },
          {
            logo: 'https://pic1.zhuanstatic.com/zhuanzh/50b4d2c9-0dfc-4e26-9284-d091027c37a8.png',
            name: '无系统异常',
          },
        ],
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.$legoAreaExposure && this.$legoAreaExposure()
      })
    },
    computed: {
      $setPicSize() {
        return setPicSize
      },
      headMsg() {
        return {
          title: this.commentPopup.title,
          text: this.commentPopup.subTitle,
        }
      },
      popupInfoData() {
        if (this.infoData && this.infoData.length) {
          return this.infoData
        } else {
          const dialogData =
            this.commentPopup &&
            this.commentPopup.tables &&
            this.commentPopup.tables.map((item) => {
              return {
                name: item.title,
                desc: item.desc,
              }
            })
          return dialogData
        }
      },
    },
    methods: {
      _showPopup() {
        try {
          this._getCommitment()
        } catch (error) {
          console.log(error)
        }
      },
      close() {
        this.showPopup = false
      },
      async _getCommitment() {
        const { data = [] } = await getCommitment()
        if (data) {
          this.showPopup = true
          this.commentPopup = data
        }
      },
      feedbackCallback(val) {
        this.feedbackVal = !!val
      },
    },
    watch: {
      infoData: {
        handler(val) {
          if (val && val.length) {
            this.officialInfo = val.filter((item) => item.explicit === true)
            this.officialInfo = this.officialInfo.slice(0, 4)
          }
        },
        immediate: true,
      },
    },
  }
</script>
<style lang="scss">
  .b2c-offical-wrapper-ab {
    // height: 300px;
    padding: 20px 0 40px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    margin-bottom: 10px;
    .offical-bar {
      // display: flex;
      // justify-content: space-between;
      margin-top: 20px;
      padding: 0 0 0 44px;
      position: relative;
      &-item {
        // display: inline-flex;
        // width: 120px;
        flex-direction: column;
        align-items: center;
        display: inline-flex;
        margin-right: 36px;
        // width: 100px;
        img {
          height: 44px;
          width: 44px;
        }
        span {
          width: auto;
          max-width: 150px;
          display: block;
          margin-top: 18px;
          font-size: 20px;
          font-family: PingFangSC-Light, PingFang SC;
          font-weight: 300;
          color: #111;
          line-height: 20px;
          text-align: center;
        }
      }
      &-more {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-50%);
        height: 100px;
        width: 28px;
        margin-top: 0px;
        margin-right: 3px;
        background: linear-gradient(270deg, #f7f7f7 0%, #f2f2f2 100%);
        border-radius: 4px 0px 0px 4px;
        font-size: 16px;
        font-family: PingFangSC-Light, PingFang SC;
        font-weight: 300;
        color: #111111;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        line-height: 22px;
        border-radius: 8px 0 0 8px;
      }
    }
    .b2c-popup-content {
      height: calc(100% - 230px);
      overflow-y: scroll;
      padding: 0 32px;
      padding-bottom: constant(safe-area-inset-bottom);
      padding-bottom: env(safe-area-inset-bottom);
      box-sizing: border-box;
      .popup-item {
        display: flex;
        margin-bottom: 4px;
        font-size: 24px;
        font-family: PingFangSC-Semibold, PingFang SC;
        .desc_title {
          padding: 0 20px;
          display: flex;
          width: 208px;
          box-sizing: border-box;
          justify-content: center;
          align-items: center;
          font-weight: 600;
          color: #000000;
          line-height: 32px;
          margin-right: 4px;
          background: #f8f8f8;
          text-align: center;
        }
        .desc_value {
          font-family: PingFangSC-Regular, PingFang SC;
          padding: 32px;
          flex: 1;
          display: flex;
          justify-content: center;
          align-items: center;
          font-weight: 400;
          color: #999999;
          line-height: 40px;
          background: #f8f8f8;
        }
      }
      .popup-desc {
        margin-top: 28px;
        text-align: center;
        font-size: 22px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        line-height: 40px;
      }
      .feed-back {
        margin-top: 83px;
        padding-bottom: 24px;
      }
    }
  }
</style>
